import { Text } from '@user-portal/wikr-components';
import React, { useEffect, useState } from 'react';

import { getDeepLinkRequest } from 'store/deepLink/actions';
import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';
import { selectDeepLink } from 'store/deepLink/selectors';
import { createProcessingSelector } from 'store/loading/selectors';

import { useDispatch, useSelector } from 'hooks/store';

import { CollapsiblePanel, QRCode } from './components';
import * as S from './DownloadAppModule.styled';
import { useDownloadAppCopy } from './useDownloadAppCopy';

import { INSTALL_APP } from '@/analytics/constants/ids';
import { trackInstructionsClick, trackPlanLinkClick } from '@/analytics/trackers/installApp';
import { useHandleContactRequest } from '@/hooks/common/useHandleContactRequest';

export const DownloadAppModule = () => {
    const [isCollapsibleOpen, setIsCollapsibleOpen] = useState(false);
    const dispatch = useDispatch();
    const { main, panel, instructions, support } = useDownloadAppCopy();
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));
    const deepLinkUrl = useSelector(selectDeepLink);
    const { isLoading: isContactLoading, onClick } = useHandleContactRequest();

    useEffect(() => {
        if (!deepLinkUrl) {
            dispatch(getDeepLinkRequest());
        }
    }, [dispatch, deepLinkUrl]);

    const handleClick = () => {
        onClick();
    };

    const handleOpenPanel = () => {
        trackInstructionsClick(INSTALL_APP);
        setIsCollapsibleOpen((prev) => !prev);
    };

    const handleLinkClick = () => {
        trackPlanLinkClick(INSTALL_APP);
    };

    return (
        <S.Container $isOpen={isCollapsibleOpen} data-testid="download-app-module">
            <Text type="h5" bold>
                {main.title}
            </Text>
            <S.Wrapper>
                <QRCode deepLinkUrl={deepLinkUrl} isLoading={isLoading} />
                <Text color="text-main" bold mt={20}>
                    {main.subtitle}
                </Text>
                <Text color="text-secondary" mb={20}>
                    {main.description}
                </Text>

                <CollapsiblePanel
                    items={instructions}
                    isOpen={isCollapsibleOpen}
                    onToggle={handleOpenPanel}
                    expandedText={panel.open}
                    collapsedText={panel.closed}
                />

                <Text color="text-main" bold mt={32}>
                    {support.title}
                </Text>
                <Text color="text-secondary">{support.description}</Text>
                <S.SupportButton
                    dataTestId="support-button"
                    size="small"
                    onClick={handleClick}
                    isLoading={isContactLoading}
                >
                    {support.button}
                </S.SupportButton>
                <S.PlanLink data-testid="plan-link" to="/workout/plan" onClick={handleLinkClick}>
                    <Text bold type="link">
                        {support.link}
                    </Text>
                </S.PlanLink>
            </S.Wrapper>
        </S.Container>
    );
};
